import React from "react";
import { motion } from "framer-motion";
import { Stage, useStageMotion } from "@/components/Stage";
import { Eyebrow } from "@/components/Wordmark";

export const AppendixSlide = ({ slide }) => {
  const { container, item } = useStageMotion();

  return (
    <Stage testId={`appendix-${slide?.id}`}>
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="h-full w-full flex flex-col justify-center px-[clamp(32px,9%,120px)] py-[clamp(36px,8%,80px)]"
      >
        <motion.div variants={item} className="mb-6">
          <Eyebrow>{slide?.kicker}</Eyebrow>
        </motion.div>

        <motion.h1
          variants={item}
          className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.03] text-ink max-w-4xl"
        >
          {slide?.title}
        </motion.h1>

        <motion.p
          variants={item}
          className="mt-6 text-base sm:text-lg text-ink-soft leading-relaxed max-w-2xl"
        >
          {slide?.subtitle}
        </motion.p>
      </motion.div>
    </Stage>
  );
};

export default AppendixSlide;
